module.exports = __webpack_public_path__ + "static/publish_395x275-ceed7fdd665603e8704fab1d1f161c16.webp";